import React from 'react'
import { useTheme } from '../context/ThemeContext'

interface GlassPanelProps {
  children: React.ReactNode
  className?: string
  variant?: 'default' | 'elevated' | 'subtle'
}

const GlassPanel: React.FC<GlassPanelProps> = ({ 
  children, 
  className = '',
  variant = 'default'
}) => {
  const { theme } = useTheme();
  
  const getVariantClasses = () => {
    if (theme === 'dark') {
      return {
        default: 'bg-white/10 border-white/20',
        elevated: 'bg-white/15 border-white/30 shadow-lg',
        subtle: 'bg-white/5 border-white/10 shadow-sm',
      }[variant];
    } else {
      return {
        default: 'bg-white/70 border-blue-100',
        elevated: 'bg-gradient-to-br from-white to-[#F5F7FF] border-blue-200 shadow-lg',
        subtle: 'bg-[#F5F7FF]/70 border-blue-50 shadow-sm',
      }[variant];
    }
  };
  
  return (
    <div
      className={`
        ${getVariantClasses()}
        backdrop-blur-md
        rounded-lg
        border
        ${theme === 'dark' ? 'shadow-black/20' : 'shadow-blue-200/30'}
        p-4
        transition-all duration-300
        ${theme === 'light' && 'hover:shadow-blue-300/20'}
        ${className}
      `}
    >
      {children}
    </div>
  )
}

export default GlassPanel
